module.exports = __webpack_public_path__ + "static/media/snowflake_3.4c060cbe.png";